import useWebShare from './use-web-share';
import React, { useCallback } from 'react';

const useWebShareHtmlAsImage = (
	htmlRef?: React.RefObject<HTMLDivElement | null>,
	onShareSuccess?: () => void,
	onShareError?: () => void
) => {
	const { share, canShare, isSupported } = useWebShare(onShareSuccess, onShareError);

	const shareHtmlAsImage = useCallback(async () => {
		try {
			if (!htmlRef || !htmlRef.current) {
				throw new Error('Ref is not provided');
			}

			const { toBlob } = await import(/* webpackChunkName: 'html-to-image' */ 'html-to-image');
			const imgBlob = await toBlob(htmlRef.current);
			if (!imgBlob) {
				throw new Error('Could not convert html to image');
			}
			const img = new File([imgBlob], 'img.jpg', {
				type: imgBlob.type,
				lastModified: new Date().getTime()
			});

			const dataToShare = {
				files: [img]
			};
			const isDataSharable = canShare(dataToShare);
			if (!isDataSharable) {
				throw new Error('Image created from html is not sharable');
			}

			await share(dataToShare);
		} catch {
			// eslint-disable-next-line no-console
			console.warn('Could not share html as image');
			if (onShareError) {
				onShareError();
			}
		}
	}, [canShare, htmlRef, onShareError, share]);

	return {
		isSupported,
		shareHtmlAsImage
	};
};

export default useWebShareHtmlAsImage;
